import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useState, createContext, useContext } from 'react';

const useGlobalSnackbar = () => {
    return useContext(SnackbarContext);
};
const SnackbarContext = createContext(null);

const SnackbarContextProvider = ({ children }) => {
    const [globalSnackbar, setGlobalSnackbar] = useState({ open: false, message: "", severity: "info" });
    return (
        <SnackbarContext.Provider value={setGlobalSnackbar}>
            {children}
            <Snackbar
                open={globalSnackbar?.open}
                message={globalSnackbar?.message}
                // TransitionComponent={SlideTransition}
                onClose={(e, reason) => {
                    if (reason === "clickaway") return;
                    //if there's an onclose event call it
                    if (globalSnackbar?.onClose) {
                        globalSnackbar.onClose();
                    }
                    setGlobalSnackbar(prevSnack => ({ ...prevSnack, open: false, onClose: null }));
                }}
            >
                <Alert
                    severity={globalSnackbar?.severity}
                    onClose={() => {
                        //if there's an onclose event call it
                        if (globalSnackbar?.onClose) {
                            globalSnackbar.onClose();
                        }
                        setGlobalSnackbar(prevSnack => ({ ...prevSnack, open: false, onClose: null }));
                    }}>
                    {typeof globalSnackbar?.message === "function" ? globalSnackbar?.message() : globalSnackbar?.message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export default SnackbarContextProvider;
export { useGlobalSnackbar };